import type { CSSProperties, FC } from "react";
import mapCdnToImgix from "./helpers/mapCdnToImgix";
import type ImgProps from "./ImgProps";

const FILL_STYLE: CSSProperties = {
  position: "absolute",
  inset: 0,
  width: "100%",
  height: "100%",
};

const Img: FC<ImgProps> = (props) => {
  const [, path] = props.src.split("//");

  if (!path) {
    return null;
  }

  const {
    crop,
    dpr,
    fetchPriority,
    fill,
    fit,
    mark,
    mask,
    mono,
    preload,
    quality,
    style,
    ...imageProps
  } = props;

  const url = new URL(`https://${mapCdnToImgix(path)}`);
  url.searchParams.set("auto", "compress,format");
  if (mask) {
    url.searchParams.set("mask", mask);
  }
  if (mono) {
    url.searchParams.set("mono", mono);
  }
  if (props.width) {
    url.searchParams.set("w", props.width.toString());
  }
  if (props.height) {
    url.searchParams.set("h", props.height.toString());
  }
  url.searchParams.set("fit", fit ?? "max");
  if (crop) {
    url.searchParams.set("crop", crop);
  }
  if (dpr) {
    url.searchParams.set("dpr", dpr.toString());
  }
  url.searchParams.set("q", (quality ?? 50).toString());
  if (mark) {
    url.searchParams.set("mark", mark);
    url.searchParams.set("mark-pad", "0");
    url.searchParams.set("mark-scale", "100");
  }

  return (
    <img
      {...imageProps}
      fetchPriority={fetchPriority ?? (preload ? "high" : undefined)}
      // Lazy by default: React preloads every eager <img> inside a Suspense boundary, ahead of the LCP image.
      loading={preload ? "eager" : (imageProps.loading ?? "lazy")}
      src={url.href}
      style={fill ? { ...FILL_STYLE, ...style } : style}
    />
  );
};

export default Img;
